import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import icon from "icons/regular/pencil.svg";
import BookReviewText from "components/BookReview/BookReviewText";
import { Link } from "@inertiajs/react";
import { ReadingJournalEventProps } from "./types";

export default function ListBook({
  journal,
  book,
  user,
}: ReadingJournalEventProps) {
  return (
    <div>
      <Text variant="secondary" className="flex flex-row items-center gap-2">
        <Icon icon={icon} />
        <span>Reviewed</span>
      </Text>

      {journal.metadata.review ? (
        <>
          <BookReviewText
            expanded={false}
            reviewSlate={journal.metadata.review}
          />
        </>
      ) : (
        false
      )}
      <p className="mt-2 text-right">
        <Link
          href={`/books/${book.slug}/reviews/@${user.username}`}
          className="text-indigo-600 dark:text-yellow-400 hover:underline"
        >
          Read full review
        </Link>
      </p>
    </div>
  );
}
